/**
 * Raves this page KNOWS the account attends — told the moment it happens (the user, 2026-10-27: "when I
 * signed in through the heart it got into the rave without attending, so the live card doesn't work —
 * if a user is saving a set, it automatically attends the rave if it's not attended").
 *
 * `attendsRave` (`offline/OfflineProvider.tsx`) asks `/me/festivals` once, when a rave opens, and the
 * always-on card (`useAttendsRave`) and the offline download wait on that answer. A rave attended after
 * that — by Attend, or by saving a set — is noted here and both hear it at once. The server attends on a
 * save too (`attendance/routes.ts` `attendBySaving`), so a save that waited offline still attends.
 */
import { endpoints } from './api';

const attended = new Set<string>();
const listeners = new Set<(editionId: string) => void>();

/** The account attends this rave — say so to every listener. */
export function noteAttending(editionId: string): void {
  if (attended.has(editionId)) return;
  attended.add(editionId);
  for (const listener of listeners) listener(editionId);
}

export function knownAttending(editionId: string): boolean {
  return attended.has(editionId);
}

export function onAttending(listener: (editionId: string) => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

const asking = new Set<string>();

/**
 * A set was saved: attend its rave unless this page already knows it does. Never awaited by the save
 * and never in its way — offline or refused (a paid rave not bought), the server's own rule decides
 * when the save reaches it. The attend route is idempotent.
 */
export function attendForSave(editionId: string): void {
  if (attended.has(editionId) || asking.has(editionId)) return;
  asking.add(editionId);
  endpoints.attend(editionId).then(() => noteAttending(editionId), () => {}).finally(() => asking.delete(editionId));
}

/** Tests: a fresh page — nothing known yet. */
export function forgetAttendingForTests(): void {
  attended.clear();
  asking.clear();
}
